import {maltStrategyCreationSteps} from '@/profile-creation-wizard/config/steps/MaltStrategyCreationSteps';
import {CreationStepName, ProfileCreationFunnelMode, RoutesConfig} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';

export default function maltStrategyRoutesConfiguration(withAccountCreation: boolean): RoutesConfig {
    const strategyCreationRoutes = maltStrategyCreationSteps(withAccountCreation).map((step) =>
        ProfileCreationRouterHelper.buildRouteFromStep(step, ProfileCreationFunnelMode.STRATEGY),
    );

    return {
        routes: strategyCreationRoutes,
        creationFirstStep: CreationStepName.SIGNUP_INTRODUCTION,
        completionFirstStep: CreationStepName.COMPLETION_LINKEDIN,
    };
}
